import { Eye as EyeIcon, EyeOff as EyeOffIcon } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  const [types, setTypes] = React.useState<string>('text')
  const [isShow, setIsShow] = React.useState(false)
  const Eye = isShow ? EyeIcon : EyeOffIcon

  React.useEffect(() => {
    if (type === 'password') {
      setTypes(isShow ? 'text' : 'password')
    } else {
      setTypes(type || 'text')
    }
  }, [isShow, type])

  return (
    <div className="relative w-full">
      <input
        type={types}
        className={cn(
          'flex h-14 w-full rounded-md border-2 border-transparent bg-gray-100 p-4 font-medium ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus:outline-none focus:border-2 focus:border-gray-900 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />

      {type === 'password' && (
        <Eye
          className="absolute w-5 h-5 cursor-pointer right-3 -translate-y-[50%] top-[50%]"
          onClick={() => setIsShow(!isShow)}
        />
      )}
    </div>
  )
})
Input.displayName = 'Input'

export { Input }
